<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="子标题" prop="subTitle">
          <el-input
            v-model="form.subTitle"
            class="fix-width"
            placeholder="请输入子标题"
          />
        </el-form-item>
        <el-form-item label="封面大小">
          <el-radio-group v-model="form.avatarSize" size="mini">
            <el-radio-button :label="0">正方形</el-radio-button>
            <el-radio-button :label="1">长方形</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="封面" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img
              v-if="form.avatar"
              :src="form.avatar"
              :class="['avatar', form.avatarSize === 1 ? 'large' : '']"
            />
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>
            建议尺寸：{{
              form.avatarSize === 1 ? '343px * 164px' : '167px * 167px'
            }}
          </span>
        </el-form-item>
        <el-form-item label="轮播图" prop="imageList">
          <el-upload
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.imageList"
            :on-success="imageList_success"
            :on-remove="imageList_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input-number v-model="form.price" placeholder="请输入价格" />
        </el-form-item>
        <el-form-item label="划线价" prop="marketPrice">
          <el-input-number
            v-model="form.marketPrice"
            placeholder="请输入价格"
          />
        </el-form-item>
        <el-form-item label="库存" prop="balance">
          <el-input-number v-model="form.balance" placeholder="请输入库存" />
        </el-form-item>
        <el-form-item label="是否显示库存">
          <el-radio-group v-model="form.showStockCount">
            <el-radio :label="0">隐藏</el-radio>
            <el-radio :label="1">显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否显示已售">
          <el-radio-group v-model="form.showSoldCount">
            <el-radio :label="0">隐藏</el-radio>
            <el-radio :label="1">显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否推荐首页">
          <el-radio-group v-model="form.showAtIndexPage">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
          <span class="tips">注：最多显示20个</span>
        </el-form-item>
        <el-form-item label="描述参数">
          <el-button
            type="primary"
            size="mini"
            class="mb-10"
            @click="addDesc(null)"
          >
            增加
          </el-button>
          <el-table stripe :data="form.descList">
            <el-table-column align="left" label="序号" width="55">
              <template #default="{ $index }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="参数名称"
              prop="key"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="参数值"
              prop="value"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              fixed="right"
              label="操作"
              show-overflow-tooltip
              width="80px"
            >
              <template #default="{ $index }">
                <el-button type="text" @click="delDesc($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="购买须知" prop="note">
          <el-input
            v-model="form.note"
            type="textarea"
            class="fix-width"
            placeholder="请输入购买须知"
          />
        </el-form-item>
        <el-form-item label="详情" prop="text">
          <tinymce-editor
            :height="460"
            :value="form.text"
            @inputChange="inputChange"
          ></tinymce-editor>
        </el-form-item>
        <el-form-item label="发货方式" prop="shipTypeList">
          <el-checkbox-group v-model="form.shipTypeList">
            <el-checkbox :label="1">在线</el-checkbox>
            <el-checkbox :label="2">到店自取</el-checkbox>
            <el-checkbox :label="3">快递配送</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="促销标记" prop="promoteFlag">
          <el-radio-group v-model="form.promoteFlag">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">超值预售</el-radio>
            <el-radio :label="2">限时促销</el-radio>
            <el-radio :label="3">限量发售</el-radio>
            <el-radio :label="4">超值优享</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 分账方 -->
        <el-form-item label="分账方">
          <el-button
            type="primary"
            size="mini"
            class="mb-10"
            @click="addSplitAccount(null)"
          >
            增加
          </el-button>
          <el-table stripe :data="form.commissionList">
            <el-table-column align="left" label="序号" width="55">
              <template #default="{ $index }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="名称"
              prop="title"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="分帐方ID"
              prop="receiverId"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="比例"
              prop="percent"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              fixed="right"
              label="操作"
              show-overflow-tooltip
              width="80px"
            >
              <template #default="{ $index }">
                <el-button type="text" @click="delSplitAccount($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- 分账方 -->
        <el-form-item label="标签列表" prop="tagIdList">
          <el-select
            class="fix-width"
            v-model="form.tagIdList"
            multiple
            filterable
            remote
            :remote-method="querySearchAsync"
            @focus="querySearchAsync"
            no-data-text="暂无数据"
            placeholder="查询商品标签"
          >
            <el-option
              v-for="item in tagList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="限制收货地址" prop="forbidReceiveAddressList">
          <el-tag
            class="tags"
            :key="index"
            v-for="(addr, index) in forbidReceiveAddressList"
            closable
            :disable-transitions="false"
            @close="handleAddrClose(addr)"
          >
            {{ addr }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="addrInputVisible"
            v-model="addrInputValue"
            @focus="inputFocus"
            ref="saveAddrInput"
            size="small"
            @keyup.enter="handleAddrInputConfirm"
            @blur="handleAddrInputConfirm"
          ></el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showAddrInput"
          >
            新增省份
          </el-button>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
    <el-dialog
      v-model="descFormVisible"
      :close-on-click-modal="false"
      title="添加描述参数"
      width="600px"
      @close="descClose"
    >
      <el-form
        ref="descForm"
        label-width="120px"
        :model="descForm"
        :rules="descFormRules"
      >
        <el-form-item label="参数名称" prop="key">
          <el-input v-model="descForm.key" placeholder="请输入参数名称" />
        </el-form-item>
        <el-form-item label="参数值" prop="value">
          <el-input v-model="descForm.value" placeholder="请输入参数值" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="descClose">取 消</el-button>
        <el-button type="primary" @click="descSave">确 定</el-button>
      </template>
    </el-dialog>
        <el-dialog
      v-model="splitAccountFormVisible"
      :close-on-click-modal="false"
      title="添加分账方"
      width="800px"
      @close="SplitClose"
    >
      <el-form
        ref="splitForm"
        label-width="120px"
        :model="splitForm"
        :rules="splitFormRules"
      >
        <el-form-item label="名称" prop="title">
          <el-input class="fix-width" v-model="splitForm.title" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="分账方" prop="receiverId">
          <el-select
            class="fix-width"
            v-model="splitForm.receiverId"
            filterable
            remote
            :remote-method="searchSplitAccount"
            @focus="searchSplitAccount"
            no-data-text="暂无数据"
            placeholder="查询分账方"
          >
            <el-option
              v-for="item in accountList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="比例" prop="percent">
          <el-input-number :min="0" :max="1" :step="0.1" class="fix-width" v-model="splitForm.percent" placeholder="请输入比例" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="SplitClose">取 消</el-button>
        <el-button type="primary" @click="splitSave">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createProduct, updateProduct, findTagAll } from '@/api/shop'
import { findReceiverList } from '@/api/splitAccount'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'ProductEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken: null,
      tagList: [],
      accountList:[],
      forbidReceiveAddressList: [],
      form: {
        productId: '',
        title: '',
        subTitle: '',
        avatarSize: 0,
        avatar: '',
        imageList: [],
        price: 0,
        marketPrice: 0,
        balance: '',
        descList: [],
        commissionList:[],
        text: '',
        note: '',
        shipTypeList: [],
        forbidReceiveAddressList: [],
        promoteFlag: 0,
        tagIdList: [],
        showSoldCount: 0,
        showStockCount: 0,
        showAtIndexPage: 0,
        order: 1,
      },
      descForm: {
        key: '',
        value: '',
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        avatar: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传封面'))
              } else {
                callback()
              }
            },
          },
        ],
        price: [{ required: true, trigger: 'blur', message: '请输入商品价格' }],
      },
      descFormRules: {
        key: [{ required: true, trigger: 'blur', message: '请输入参数名称' }],
        value: [{ required: true, trigger: 'blur', message: '请输入参数值' }],
      },
      splitForm:{
        title:'',
        receiverId:'',
        percent:''
      },
      splitFormRules: {
        title: [{ required: true, trigger: 'blur', message: '请输入名称' }],
        receiverId: [{ required: true, trigger: 'blur', message: '请选择分账方' }],
        percent: [{ required: true, trigger: 'blur', message: '请填写比例' }],
      },
      dialogFormVisible: false,
      descFormVisible: false,
      addrInputVisible: false,
      addrInputValue: '',
      //fenzhang
      splitAccountFormVisible:false,
    }
  },
  methods: {
    inputChange(value) {
      this.form.text = value
    },
    addDesc() {
      this.descFormVisible = true
    },
    addSplitAccount() {
      this.splitAccountFormVisible = true
    },
    descSave() {
      this.$refs['descForm'].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({}, this.descForm)
          this.form.descList.push(form)
          this.descClose()
        } else {
          return false
        }
      })
    },
    splitSave() {
      this.$refs['splitForm'].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({}, this.splitForm)
          this.form.commissionList.push(form)
          this.SplitClose()
        } else {
          return false
        }
      })
    },
    delDesc(index) {
      this.form.descList.splice(index, 1)
    },
    delSplitAccount(index) {
      this.form.commissionList.splice(index, 1)
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改商品'
        this.form = Object.assign(this.form, row.basic)
        this.form.productId = row.productId
        this.form.title = row.title
        this.form.step = row.step
        this.form.balance = row.basic.stock.balance
        this.tagList = this.backShowTags(row)
        this.forbidReceiveAddressList = [
          ...(row.basic.forbidReceiveAddressList || []),
        ]
      } else {
        this.title = '新增商品'
        this.forbidReceiveAddressList = []
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    handleAddrClose(addr) {
      this.forbidReceiveAddressList.splice(
        this.forbidReceiveAddressList.indexOf(addr),
        1
      )
    },
    showAddrInput() {
      this.addrInputVisible = true
      this.$nextTick(() => {
        this.$refs.saveAddrInput.$refs.input.focus()
      })
    },
    handleAddrInputConfirm() {
      const inputValue = this.addrInputValue.trim()
      if (inputValue) {
        this.forbidReceiveAddressList.push(inputValue)
      }
      this.addrInputVisible = false
      this.addrInputValue = ''
    },
    backShowTags(row) {
      const ids = row.basic.tagIdList
      const names = row.tags
      const tags = []
      for (var i = 0; i < ids.length; i++) {
        tags.push({
          label: `${(names[i] && names[i].title) || ''}`,
          value: ids[i],
        })
      }
      console.log(tags)
      return tags
    },
    // 图片
    imageList_remove(file, fileList) {
      this.form.imageList = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    image_remove(file, fileList) {
      // this.form.avatar = fileList.map((e) => ({
      //   name: e.name,
      //   url: e.url,
      // }))
      this.form.avatar = ''
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.avatar = `${QNHost}/${res.hash}`
    },
    imageList_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.imageList.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    descClose() {
      this.$refs['descForm'].resetFields()
      this.descForm = this.$options.data().descForm
      this.descFormVisible = false
    },
    SplitClose() {
      this.$refs['splitForm'].resetFields()
      this.splitForm = this.$options.data().splitForm
      this.splitAccountFormVisible = false
    },
    async querySearchAsync(queryString) {
      try {
        const keyword = typeof queryString == 'object' ? '' : queryString
        const ret = await findTagAll({
          //   page: 1,
          //   size: 100,
          keyword,
        })
        console.log(ret)
        this.tagList = ret.map((e) => ({
          label: e.title,
          value: e.tagId,
        }))
      } catch (error) {
        this.tagList = []
      }
    },
    async searchSplitAccount(queryString) {
      try {
        const keyword = typeof queryString == 'object' ? '' : queryString
        const ret = await findReceiverList({
            page: 1,
            size: 10000,
            keyword,
        })
        console.log(ret)
        this.accountList = ret.list.map((e) => ({
          label: e.title,
          value: e.receiverId,
        }))
      } catch (error) {
        this.accountList = []
      }
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const productId = this.form.productId
          //处理数据 图片数组转string
          const data = Object.assign({}, this.form)
          data.forbidReceiveAddressList = this.forbidReceiveAddressList
          this.$baseConfirm(
            `你确定要${productId ? '修改' : '新增'}商品吗`,
            null,
            async () => {
              productId ? await updateProduct(data) : await createProduct(data)
              this.$baseMessage(
                `${productId ? '修改' : '新增'}商品成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
</style>
